export default "d01d99fb9458a263.ttf"